var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "occupation-deed-owners" },
    [
      _vm._l(_vm.holders, function (holder, idx) {
        return _c(
          "div",
          {
            key: `occupation-deed-owners-person-item-${idx}`,
            staticClass: "person",
          },
          [
            _c("PersonItem", {
              attrs: {
                value: holder.entity,
                panelCfg: _vm.panelCfg,
                personType: "holder",
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-application-info" },
        [
          _vm._l(_vm.commonInfo, function (key, idx) {
            return [
              _vm.itemInfo(key)
                ? _c(
                    "div",
                    {
                      key: `occupation-deed-owners-common-${idx}`,
                      class: ["info-item", key],
                    },
                    [
                      _c("label", { staticClass: "pr-2" }, [
                        _vm._v(
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.${key}`)) + ":"
                        ),
                      ]),
                      _vm._v(_vm._s(_vm.itemInfo(key)) + "\n            "),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.fee
            ? _c("div", { staticClass: "fee-info" }, [
                _c("div", { staticClass: "fee_charged" }, [
                  _c("span", { staticClass: "fee" }, [
                    _vm._v(_vm._s(_vm.feeFormatted)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { class: ["fee-paid", { "is-charged": _vm.feePaid }] },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            `${_vm.modelTranslateID}.${
                              _vm.feePaid ? "paid" : "not_paid"
                            }`
                          )
                        )
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "payment-date" }, [
                  _c("span", { staticClass: "payment-date" }, [
                    _vm._v(_vm._s(_vm.itemInfo("payment_at"))),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.numFiles
        ? _c(
            "div",
            { staticClass: "deed-owners-files" },
            [
              _c("p", [
                _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.files`)) + " "),
                _c("span", [_vm._v(_vm._s(_vm.numFiles))]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.files, function (file, idx) {
                return _c("ViewFile", {
                  key: `occupation-deed-owners-file-${idx}`,
                  attrs: { value: file },
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }